import { css } from 'lit';

export default css`
  :host {
    display: block;
    font-family: var(--font-family-base, 'Inter, Arial, sans-serif');
    --popup-width: 350px;
    --popup-bg: var(--color-gray-1, #f7f5f4);
    --popup-border: var(--sm-line, 1.5px) solid var(--color-gray-2, #e7e5e4);
    --popup-padding: var(--spacing-lg, 24px);
    --overlay-bg: rgba(0, 0, 0, 0.5);
    --z-index-dialog: 2000;
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--overlay-bg);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: var(--z-index-dialog);
    overscroll-behavior: contain;  
  }

  .popup {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: var(--popup-padding);
    gap: var(--spacing-lg, 24px);
    width: var(--popup-width);
    max-width: 90vw;
    background: var(--popup-bg);
    border: var(--popup-border);
    border-radius: var(--radius-md, 12px);
    box-sizing: border-box;
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--spacing-xxs, 4px);
    width: 100%;
  }

  .title, ::slotted([slot="title"]) {
    width: 100%;
    font-size: var(--font-size-s2, 16px);
    line-height: var(--line-height-s2, 24px);
    font-weight: var(--font-weight-semibold, 600);
    color: var(--color-dark-gray, #1c2321);
    text-align: center;
  }

  .message, ::slotted([slot="message"]) {
    width: 100%;
    font-size: var(--font-size-b3, 14px);
    line-height: var(--line-height-b3, 20px);
    font-weight: var(--font-weight-regular, 400);
    color: var(--color-gray-6, #7c7c7c);
    text-align: center;
  }

  .input-wrapper {
    width: 100%;
  }

  input, ::slotted([slot="input"]) {
    width: 100%;
    height: 48px;
    padding: var(--spacing-sm, 12px);
    border: var(--sm-line, 1.5px) solid var(--color-gray-3, #d7d4d2);
    border-radius: var(--radius-md, 12px);
    background: var(--color-white, #ffffff);
    font-size: var(--font-size-b1, 16px);
    line-height: var(--line-height-b1, 24px);
    color: var(--color-gray-6, #7c7c7c);
    box-sizing: border-box;
  }

  input::placeholder, ::slotted([slot="input"])::placeholder {
    color: var(--color-gray-6, #7c7c7c);
  }

  .buttons {
    width: 100%;
    display: flex;
    gap: var(--spacing-md, 16px);
  }

  .buttons.vertical {
    flex-direction: column;
  }

  .buttons.horizontal {
    flex-direction: row;
  }

  .buttons.single {
    flex-direction: column;
  }

  button, ::slotted([slot="primary-button"]), ::slotted([slot="secondary-button"]) {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 14px 20px;
    height: 48px;
    border-radius: var(--radius-md, 12px);
    font-size: var(--font-size-button-large, 16px);
    line-height: var(--line-height-button-large, 20px);
    font-weight: var(--font-weight-semibold, 600);
    cursor: pointer;
    box-sizing: border-box;
    width: 100%;
  }

  .primary, ::slotted([slot="primary-button"]) {
    background: var(--color-primary-dark, #001d68);
    color: var(--color-white, #ffffff);
    border: none;
  }

  .secondary, ::slotted([slot="secondary-button"]) {
    background: var(--color-white, #ffffff);
    border: var(--sm-line, 1.5px) solid var(--color-hover);
    color: var(--color-hover);
  }

  .buttons.horizontal .primary,
  .buttons.horizontal .secondary,
  .buttons.horizontal ::slotted([slot="primary-button"]),
  .buttons.horizontal ::slotted([slot="secondary-button"]) {
    width: calc(50% - var(--spacing-md, 16px) / 2);
  }

  @media (max-width: 768px) {
    .popup {
      width: 90vw;
      padding: var(--spacing-md, 16px);
    }
    .buttons.horizontal {
      flex-direction: column;
      gap: var(--spacing-sm, 12px);
    }
    .buttons.horizontal .primary,
    .buttons.horizontal .secondary,
    .buttons.horizontal ::slotted([slot="primary-button"]),
    .buttons.horizontal ::slotted([slot="secondary-button"]) {
      width: 100%;
    }
  }
`;